var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { Leaf, BranchNode, ChildrenAnalyzer } from "@contember/react-multipass-rendering";
import { BindingError } from "../BindingError.js";
import { IncrementalMarkerBuilder } from "./IncrementalMarkerBuilder.js";
import { Environment } from "../dao/Environment.js";
import { MarkerTreeRoot } from "../markers/MarkerTreeRoot.js";
import { EntityFieldMarkersContainer } from "../markers/EntityFieldMarkersContainer.js";
const _MarkerTreeGenerator = class {
  constructor(sourceTree, environment = Environment.create()) {
    this.sourceTree = sourceTree;
    this.environment = environment;
  }
  generate() {
    const processed = _MarkerTreeGenerator.childrenAnalyzer.processChildren(this.sourceTree, this.environment);
    if (processed.length === 0) {
      return new MarkerTreeRoot(/* @__PURE__ */ new Map(), /* @__PURE__ */ new Map());
    }
    const collectedMarkers = _MarkerTreeGenerator.mapNodeResultToEntityFields(processed);
    if (collectedMarkers instanceof EntityFieldMarkersContainer) {
      throw new BindingError();
    }
    if (collectedMarkers.fields.markers.size) {
      throw new BindingError();
    }
    if (collectedMarkers.parentReference !== void 0) {
      throw new BindingError();
    }
    if (collectedMarkers.subTrees === void 0) {
      throw new BindingError();
    }
    const subTrees = collectedMarkers.subTrees;
    return new MarkerTreeRoot(subTrees, this.generatePlaceholdersByAliases(subTrees));
  }
  generatePlaceholdersByAliases(hoistedSubTrees) {
    const placeholders = /* @__PURE__ */ new Map();
    for (const [placeholderName, subTree] of hoistedSubTrees) {
      const aliases = subTree.parameters.alias;
      if (aliases === void 0 || aliases.size === 0) {
        continue;
      }
      for (const alias of aliases) {
        const existingPlaceholder = placeholders.get(alias);
        if (existingPlaceholder !== void 0) {
          if (existingPlaceholder === placeholderName) {
            continue;
          }
          throw new BindingError(
            `Detected the same sub-tree alias '${alias}' referring to sub-trees with different parameters!`
          );
        }
        placeholders.set(alias, placeholderName);
      }
    }
    return placeholders;
  }
  static mapNodeResultToEntityFields(result) {
    const builder = new IncrementalMarkerBuilder();
    if (!result) {
      return builder.getFinalMarker();
    }
    if (!Array.isArray(result)) {
      builder.mutateIn(result);
      return builder.getFinalMarker();
    }
    for (const marker of result) {
      builder.mutateIn(marker);
    }
    return builder.getFinalMarker();
  }
  static initializeChildrenAnalyzer() {
    const fieldMarkerLeaf = new Leaf("generateLeafMarker");
    const branchMarkerBranchNode = new BranchNode(
      "generateBranchMarker",
      this.mapNodeResultToEntityFields,
      { childrenAreOptional: true }
    );
    return new ChildrenAnalyzer([fieldMarkerLeaf], [branchMarkerBranchNode], {
      staticRenderFactoryName: "staticRender",
      renderPropsErrorMessage: `Render props (functions as React component children) are not supported within the schema. You have likely used a bare custom component as opposed to wrapping in with \`Component\` from the \`@contember/admin\` package. Please refer to the documentation.`,
      ignoreRenderProps: false,
      staticContextFactoryName: "generateEnvironment"
    });
  }
};
let MarkerTreeGenerator = _MarkerTreeGenerator;
__publicField(MarkerTreeGenerator, "childrenAnalyzer", _MarkerTreeGenerator.initializeChildrenAnalyzer());
export {
  MarkerTreeGenerator
};
//# sourceMappingURL=MarkerTreeGenerator.js.map
